// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:03:01

export default {
  "id": "kinder-garden",
  "slug": "kinder-garden",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/772ec582be834dcc81141460ba94320b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/772ec582be834dcc81141460ba94320b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Kinder Garden",
      "description": "Run your own daycare in this hyper-casual arcade game! Care for babies by feeding, changing diapers, and keeping them happy. Unlock new rooms, toys, and upgrades to grow your nursery. Enjoy simple controls, fun gameplay, and happy rewards. Play now!",
      "instructions": "⁃ Move with the joystick;\n⁃ Come to the diapers to take them;\n⁃ Come to the baby to change the diaper;\n⁃ Take a bottle and go to the baby to feed;\n⁃ Take the baby and go to the crib to put him to bed.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "baby",
        "babysitter",
        "family",
        "manager"
      ]
    },
    "zh-CN": {
      "title": "儿童花园",
      "description": "在这个超休闲街机游戏中，经营自己的日托所！通过喂养、换尿布和保持宝宝快乐来照顾他们。解锁新房间、玩具和升级来扩大你的育儿室。享受简单的控制、有趣的玩法和快乐的奖励。现在就玩吧！",
      "instructions": "⁃ 使用摇杆移动；\n⁃ 来到尿不湿处取尿不湿；\n⁃ 来到宝宝处换尿不湿；\n⁃ 拿起奶瓶去喂宝宝；\n⁃ 拿起宝宝去婴儿床放他睡觉。",
      "genres": [
        "模拟"
      ],
      "tags": [
        "宝宝",
        "保姆",
        "家庭",
        "经理"
      ]
    },
    "zh-TW": {
      "title": "兒童花園",
      "description": "在這款超簡單街機遊戲中經營自己的托兒所！照顧嬰兒，透過喂食、換尿布和讓他們快樂來照顧他們。解鎖新房間、玩具和升級來擴大你的育嬰室。享受簡單的操作、有趣的遊戲玩法和快樂的獎勵。現在就開始玩吧！",
      "instructions": "⁃ 用摇杆移動；\n⁃ 走到尿布那取尿布；\n⁃ 走到寶寶那換尿布；\n⁃ 拿一瓶奶去喂寶寶；\n⁃ 拿起寶寶去嬰兒床放他睡覺。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "寶寶",
        "保姆",
        "家庭",
        "經理"
      ]
    },
    "zh-HK": {
      "title": "兒童花園",
      "description": "開設你自己的兒童看護中心！在這款超簡單休閒街機遊戲中，照顧嬰兒，透過餵食、換尿布和讓他們快樂來照顧他們。解鎖新房間、玩具和升級，擴展你的育嬰室。享受簡單的操作、有趣的遊戲和快樂的獎勵。立即遊玩！",
      "instructions": "- 用摇杆移動；\n- 走到尿褲那兒拿它；\n- 走到嬰兒那兒換尿褲；\n- 拿一瓶奶去嬰兒那兒喂飽；\n- 拿起嬰兒走去嬰兒床放他上床。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "寶貝",
        "保姆",
        "家庭",
        "經理"
      ]
    },
    "ja": {
      "title": "キンダーガーデン",
      "description": "このハイパーカジュアルアーケードゲームで自分の保育園を経営しましょう！赤ちゃんを世話して、ミルクを飲ませ、おむつを替え、幸せにさせてください。新しい部屋、おもちゃ、そしてアップグレードを解禁して、保育園を拡張しましょう。シンプルな操作、楽しいゲームプレイ、そして幸せなリワードを楽しみましょう。今すぐプレイ！",
      "instructions": "- ジョイスティックで移動；\n- 尿布に近づいてそれを取る；\n- 婴児に近づいておむつを替える；\n- 奶瓶を持って婴儿に向かって給餌；\n- 婴児を持ってベッドに置く。",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "ベイビー",
        "ベイビーシッター",
        "家族",
        "マネージャー"
      ]
    },
    "ko": {
      "title": "키더 가든",
      "description": "이 하이퍼캐슐 아케이드 게임에서 자신의 돌봄소를 운영하세요! 영아를 먹이고 변기를 변환하고, 그들을 기쁘게 유지하세요. 새로운 방, 장난감, 및 업그레이드를 해금하여 돌봄실을 확장하세요. 간단한 조작, 흥미로운 게임플레이, 기쁜 보상을 즐겨보세요. 지금 즐겨보세요!",
      "instructions": "- 조이스틱으로 이동하세요;\n- 비누를 가져오기 위해 비누통으로 가세요;\n- 아기에게 가서 비누를 바꾸세요;\n- 복지를 가져와 아기에게 먹이주세요;\n- 아기를 들고 침대로 가서 잠자리에 두세요.",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "빨래",
        "돌봄",
        "가족",
        "매니저"
      ]
    },
    "fr": {
      "title": "Jardin des Enfants",
      "description": "Gérez votre propre crèche dans ce jeu d'arcade hyper-casual ! Prenez soin des bébés en les nourrissant, en changeant leurs couches et en les gardant heureux. Débloquez de nouvelles chambres, jouets et mises à jour pour élargir votre crèche. Profitez de commandes simples, d'un gameplay amusant et de récompenses heureuses. Jouez maintenant !",
      "instructions": "⁃ Déplacez-vous avec le manette;\n⁃ Allez vers les couches pour les prendre;\n⁃ Allez vers le bébé pour changer la couche;\n⁃ Prenez une bouteille et allez vers le bébé pour l'alimenter;\n⁃ Prenez le bébé et allez vers le berceau pour le coucher.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "enfant",
        "nounou",
        "famille",
        "gestionnaire"
      ]
    }
  }
};
